import React, { Fragment, useState } from "react";

import {
    TableContainer,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Chip
} from '@mui/material';

import _ from 'lodash';

import PhoneMissedIcon from '@mui/icons-material/PhoneMissed';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PhoneCallbackIcon from '@mui/icons-material/PhoneCallback';

import InboundSettings from "./InboundSettings";

import Utils from "../utils";
import { UPDATE, provider } from "../../_utils";
import { Modal } from "../../_Components";

const Inbounds = ({inbounds}) => {
    
    const [showInbound, setShowInbound] = useState(false);
    const [currentInbound, setCurrentInbound] = useState(null);
    const [currentQueueAgents, setCurrentQueueAgents] = useState(null);

    // const openInbound = (queue) => {
    //     setShowInbound(true);
    //     setCurrentInbound(queue);
    // }

    const handleInboundSettings = async () => {
        let agents = [];
        for (var i = 0; i < currentQueueAgents.length; i++) {
            agents.push(currentQueueAgents[i].login);
        }
        await provider(UPDATE, '/infra/inbound/settings', { id: currentInbound.id, data: { agents } })
            .then(() => {
                this.closeInbound();
            })
            .catch(error => {
                // showNotification(error.message, 'error');
            })
            .finally(() => {
                // fetchEnd();
            });
    }

    const handleClose = () => {
        setShowInbound(false);
        setCurrentQueueAgents(null);
        setCurrentInbound(null);
    }

    return(
        <Fragment>
            <TableContainer>
                <Table size="small" stickyHeader className="pc-dash-queues-table" aria-label="sticky table">
                    <TableHead style={{color: 'black', backgroundColor: 'unset'}}>
                        <TableRow>
                            <TableCell style={{color: 'black', backgroundColor: 'unset', fontWeight: 900}}>Очередь</TableCell>
                            <TableCell style={{color: 'black', backgroundColor: 'unset', fontWeight: 900}}><PhoneCallbackIcon style={{fontSize: '0.8rem', color: '#59af50'}}/></TableCell>
                            <TableCell style={{color: 'black', backgroundColor: 'unset', fontWeight: 900}}><PhoneMissedIcon style={{fontSize: '0.8rem', color: '#ff5722'}}/></TableCell>
                            <TableCell style={{color: 'black', backgroundColor: 'unset', fontWeight: 900}}><AccessTimeIcon style={{fontSize: '0.8rem', color: '#31708f'}}/></TableCell>
                            <TableCell style={{color: 'black', backgroundColor: 'unset', fontWeight: 900}}>SL</TableCell>
                            <TableCell style={{color: 'black', backgroundColor: 'unset', fontWeight: 900}}>Ar</TableCell>
                            <TableCell style={{color: 'black', backgroundColor: 'unset', fontWeight: 900}}>Агенты</TableCell>
                            <TableCell style={{color: 'black', backgroundColor: 'unset', fontWeight: 900}}>Вызовы</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {_.orderBy(inbounds, ['sessions.waiting', 'sessions.connected', 'statistics.answered', 'online'], ['desc', 'desc', 'desc','desc']).map((record, key) =>{
                            // let backgroundColor = 'none';
                            let color = '';
                            // let boxShadow = 'unset';
                            // let borderRadius = 'unset';
                            let active = false;
                            if(record.sessions.connected > 0&&record.sessions.waiting===0){
                                // backgroundColor = '#dff0d8';
                                // boxShadow = 'inset 0px 0px 4px rgb(47 125 49)';
                                // borderRadius =  8;
                                color = "#3c763d";
                                active = true;
                            }else if(record.sessions.waiting>1){
                                // backgroundColor = '#fffae1';
                                // boxShadow = 'inset 0px 0px 4px rgb(211 48 47)';
                                // borderRadius =  8;
                                color = "rgb(211 48 47)"
                                active = true;
                            }else if(record.sessions.waiting>0){
                                // backgroundColor = '#fffae1';
                                // boxShadow = 'inset 0px 0px 4px rgb(237 109 3)';
                                // borderRadius =  8;
                                color = "rgb(237 109 3)"
                                active = true;
                            }
                            return(
                                // boxShadow, borderRadius, backgroundColor
                                <TableRow hover tabIndex={-1} key={key}>
                                    <TableCell style={{cursor: 'pointer'}}>
                                        <div className="pc-dash-qname" style={{color, fontWeight: active ? 900 : 'unset'}}>{record.name}</div>
                                    </TableCell>
                                    <TableCell>
                                        {record.statistics&&record.statistics.answered>=0&&
                                            <span>{record.statistics.answered}</span>
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {record.statistics&&record.statistics.abandoned>=0&&
                                            <span>{record.statistics.abandoned}</span>
                                        }
                                    </TableCell>
                                    <TableCell>
                                        {record.statistics&&record.statistics.talkTime>0&&
                                            <Chip 
                                                size="small" 
                                                color="info" 
                                                variant="outlined" 
                                                label={Utils.secondsToTime(record.statistics.talkTime)} 
                                                style={{fontSize: '0.65rem', height: 16}} 
                                            />
                                        }
                                    </TableCell>
                                    <TableCell>
                                            {(record.statistics&&record.statistics.sl!==undefined)&&
                                                <Chip 
                                                    style={{fontSize: '0.65rem', height: 16}} 
                                                    size='small' 
                                                    color={record.statistics.sl<70 ? 'error' : (record.statistics.sl<80 ? 'warning' : 'success')} 
                                                    variant='outlined' 
                                                    label={`${record.statistics.sl.toFixed(2)}%`}
                                                />
                                            }
                                    </TableCell>
                                    <TableCell>
                                            {(record.statistics&&record.statistics.abandonedPercent!==undefined)&&
                                                <Chip 
                                                    style={{fontSize: '0.65rem', height: 16}} 
                                                    size='small' 
                                                    color={record.statistics.abandonedPercent>5 ? 'error' : (record.statistics.abandonedPercent>4 ? 'warning' : 'success')} 
                                                    variant='outlined' 
                                                    label={`${record.statistics.abandonedPercent.toFixed(2)}%`}
                                                />
                                            }
                                    </TableCell>
                                    <TableCell>
                                        <div style={{color}}>{record.online} / {record.available}</div>
                                    </TableCell>
                                    <TableCell>
                                        <div style={{color, fontWeight: active ? 900 : 'unset'}}>
                                            <span style={{fontWeight: active ? 900 : 'unset'}}>{record.sessions.connected}</span>
                                            {' / '}
                                            {record.sessions.waiting}
                                        </div>
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            {showInbound&&
                <Modal 
                    size="md"
                    open={showInbound} 
                    handleCloseClick={handleClose} 
                    handleSaveClick={handleInboundSettings} 
                    title={`${currentInbound.name}`} 
                    content={<InboundSettings queue={currentInbound} changeAgents={(agents)=> setCurrentQueueAgents(agents)}/>} 
                />
            }
        </Fragment>
    )
}

export default Inbounds;